// Override Settings
var boostPFSInstantSearchConfig = {
    search: {
        //suggestionMode: 'test',
        //suggestionPosition: 'left'
    }
};

(function() {
    BoostPFS.inject(this);

    $(".search-modal__form .field").show();
    $(".skeleton-loader").hide();

    function formRequest(value) {
        return new Promise((resolve, reject) => {
            var xhr = window.XMLHttpRequest ? new XMLHttpRequest() : new ActiveXObject('Microsoft.XMLHTTP');
            xhr.open("GET", value);
            xhr.setRequestHeader('Content-Type', 'application/json');
            xhr.onload = () => resolve(xhr.responseText);
            xhr.onerror = () => reject(xhr.statusText);
            xhr.send();
        });
    }

    // Customize style of Suggestion box
    SearchInput.prototype.customizeInstantSearch = function() {};

    SearchInput.prototype.afterBindEvents = function() {

        // Fix cannot close search suggestion when clicking overlay 
        document.addEventListener('click', function(e) {
            if (this.searchAutoComplete && this.searchAutoComplete.isOpen && e && e.target) {
                var $clickedElement = jQ(e.target);
                var isClickSuggestion = $clickedElement.closest('.' + Class.searchSuggestionWrapper).length > 0;
                if (isClickSuggestion) {
                    this.searchAutoComplete.$element.hide();
                    this.searchAutoComplete.searchInput.onCloseAutocomplete();
                    this.searchAutoComplete.isOpen = false;
                }
            }
        }.bind(this), true);
    }
    InstantSearchResultItemProduct.prototype.compileSuggestionProductPrice = function() {
        // If the multi-currency feature is enabled, update the product price
        this.prepareSuggestionProductPriceData();
        // Check on sale
        var onSale = this.data.compare_at_price_min > this.data.price_min;
        // Format price
        var price = Utils.formatMoney(this.data.price_min);
        var priceVaries = this.data.price_min != this.data.price_max; // Check a product has many prices
        var compareAtPrice = '';
        if (this.data && this.data.compare_at_price_min) {
            compareAtPrice = Utils.formatMoney(this.data.compare_at_price_min);
            if (Settings.getSettingValue('search.removePriceDecimal')) {
                price = Utils.removeDecimal(price);
                compareAtPrice = Utils.removeDecimal(compareAtPrice);
            }
        }

        // Build Price
        var result = '';
        if (Settings.getSettingValue('search.showSuggestionProductPrice')) {
            if (onSale && Settings.getSettingValue('search.showSuggestionProductSalePrice')) {
                result = this.getTemplate(InstantSearchResultItemProduct.tempType.PRICE_SALE);
            } else {
                result = this.getTemplate(InstantSearchResultItemProduct.tempType.PRICE);
            }
        }
        if (priceVaries) {
            result = result.replace(/{{regularPrice}}/g, 'From {{regularPrice}}');
        }
        return result
            .replace(/{{regularPrice}}/g, price)
            .replace(/{{compareAtPrice}}/g, compareAtPrice);
    }

    InstantSearchResultItemProduct.prototype.prepareSuggestionProductPriceData = function() {
		var product = this.data;
		var isRoundedPrice = true;
		if (Utils.isEnableShopifyMultipleCurrencies()) {
			// Convert on FE: by rounding rules
			if (!product.isConvertedPrice && Utils.isConvertCurrenciesOnFrontEnd()) {
				product.price_min = Utils.convertPriceBasedOnActiveCurrency(product.price_min, isRoundedPrice);
				product.price_max = Utils.convertPriceBasedOnActiveCurrency(product.price_max, isRoundedPrice);
				product.compare_at_price_min = Utils.convertPriceBasedOnActiveCurrency(product.compare_at_price_min, isRoundedPrice);
				product.compare_at_price_max = Utils.convertPriceBasedOnActiveCurrency(product.compare_at_price_max, isRoundedPrice);
				product.isConvertedPrice = true;
			// Convert on BE: by presentment price returned from API
			} else {
				Utils.convertPriceBasedOnPresentmentPrice(product);
			}
		}
	}

    Utils.convertPriceBasedOnPresentmentPrice = (productData) => {
    	var currenciesSeting = Settings.getSettingValue('general.currencies');
    	if (typeof currenciesSeting != 'undefined' && currenciesSeting.length > 1) {
    		var currentCurrency = Settings.getSettingValue('general.current_currency').toLowerCase().trim();
    		var prices = ['price_min', 'price_max', 'compare_at_price_min', 'compare_at_price_max'];
            console.log(currentCurrency);
    		prices.forEach((priceKey) => {
    			var currentPriceKey = priceKey + '_' + currentCurrency;
    			if (typeof productData[currentPriceKey] != 'undefined') {
    				productData[priceKey] = productData[currentPriceKey];
    			}
    		});
            console.log(productData)
    	}
    }
})();